import { Component } from '@angular/core';
import { MunilyTabItem } from '../../../common-components/tabs/tabs.types';

@Component({
  selector: 'app-tabs-playground',
  templateUrl: './tabs-playground.component.html',
  styleUrls: ['./tabs-playground.component.scss'],
})
export class TabsPlaygroundComponent {
  tabsWithBadges: MunilyTabItem[] = [
    { label: 'Pendientes', badgeCount: 12 },
    { label: 'En curso', badgeCount: 3 },
    { label: 'Completados', badgeCount: 0 },
    { label: 'Archivo', badgeCount: 120 },
  ];

  tabsPlain: MunilyTabItem[] = [{ label: 'Uno' }, { label: 'Dos' }, { label: 'Tres' }];

  showBadge = true;
  selectedIndex = 0;
  lastEvent = '';

  onTabChanged(i: number): void {
    this.lastEvent = `tabChanged: índice ${i}`;
  }
}
